export default __webpack_public_path__ + "static/colour_config-1e1b0ebb2544811d1ddb17e758259fcf.gif";